

// import React, { useState, useEffect } from "react";
// import './Eventssubscription.css';
// import { fetchWithAuth } from "../../../Auth/AuthFetch";
// import { useLoader } from '../../../../context/LoaderProvider.jsx';
// const API_BASE_URL = "https://backend.maamaas.com/subscription/api/subscription-plans";
// const API_KEY = "your_api_key_here";

// const ALL_POSSIBLE_MODULES = [
//     "Home", "Company", "Settings_Controls", "Account_History", "Order_Management",
//     "Menu_Management", "Inventory_Management", "Chef_Management", "Payment_Transactions",
//     "Table_Management", "Delivery_Management", "Promotions_Discounts", "Report_Analysis"
// ].sort();

// const PLAN_DURATIONS = [90, 180, 365];

// const Eventssubscriptiondata = () => {
//     const [planModuleConfig, setPlanModuleConfig] = useState({});
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [editingPlans, setEditingPlans] = useState({});
//     const { showLoader, hideLoader } = useLoader();
//     // Fetch plans
//     useEffect(() => {
//         const fetchAllPlanData = async () => {
//             try {
//                 setLoading(true);
//                 showLoader();
//                 // const token = localStorage.getItem("authToken"); // ✅ Get token from localStorage
//                 // if (!token) throw new Error("No auth token found!");

//                 const response = await fetchWithAuth('https://backend.maamaas.com/subscription/api/get/vertical/FOOD_AND_BEVERAGES', {
//                     headers: {
//                         "X-API-Key": API_KEY,
//                         "Accept": "application/json",
//                         // "Authorization": `Bearer ${token}` // ✅ Add Bearer token
//                     }
//                 });

//                 if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
//                 const data = await response.json();

//                 const config = {};
//                 ["BASIC", "PREMIUM"].forEach(planType => {
//                     config[planType] = PLAN_DURATIONS.map(days => {
//                         const existing = data.find(p => p.planType === planType && p.days === days);
//                         return existing
//                             ? {
//                                 ...existing,
//                                 price: existing.price || 0,
//                                 businessModules: Array.isArray(existing.businessModules)
//                                     ? existing.businessModules
//                                     : []
//                             }
//                             : {
//                                 id: null,
//                                 days,
//                                 price: 0,
//                                 planType,
//                                 businessModules: []
//                             };
//                     });
//                 });

//                 setPlanModuleConfig(config);
//             } catch (err) {
//                 console.error("❌ Fetch plan data failed:", err);
//                 setError(err.message);
//             } finally {
//                 setLoading(false);
//                 hideLoader();
//             }
//         };

//         fetchAllPlanData();
//     }, []);


//     // Handlers
//     const handleDaysChange = (planType, index, newDays) => {
//         setPlanModuleConfig(prev => {
//             const updated = { ...prev };
//             updated[planType][index] = { ...updated[planType][index], days: Number(newDays) };
//             return updated;
//         });
//     };

//     const handlePriceChange = (planType, days, newPrice) => {
//         setPlanModuleConfig(prev => {
//             const updated = { ...prev };
//             updated[planType] = updated[planType].map(p =>
//                 p.days === days ? { ...p, price: Number(newPrice) } : p
//             );
//             return updated;
//         });
//     };

//     const handleModuleChange = (planType, days, moduleName, isChecked) => {
//         setPlanModuleConfig(prev => {
//             const updated = { ...prev };
//             updated[planType] = updated[planType].map(plan => {
//                 if (plan.days === days) {
//                     const modules = plan.businessModules || [];
//                     return {
//                         ...plan,
//                         businessModules: isChecked
//                             ? [...new Set([...modules, moduleName])]
//                             : modules.filter(m => m !== moduleName)
//                     };
//                 }
//                 return plan;
//             });
//             return updated;
//         });
//     };

//     const handleStartEdit = planType => {
//         setEditingPlans(prev => ({ ...prev, [planType]: true }));
//     };

//     const handleStopEdit = planType => {
//         setEditingPlans(prev => ({ ...prev, [planType]: false }));
//     };

//     const handleSavePlans = async (planType) => {
//         const plans = planModuleConfig[planType] || [];
//         const savedPlans = [];

//         // ✅ Get token from localStorage
//         const token = localStorage.getItem("authToken");

//         for (let plan of plans) {
//             const payload = {
//                 price: Number(plan.price) || 0,
//                 businessModules: plan.businessModules || [],
//                 planType,
//                 businessVerticals: "FOOD_AND_BEVERAGES",
//                 days: plan.days,
//             };

//             try {
//                 // ✅ Add Authorization + API Key
//                 const headers = {
//                     "Content-Type": "application/json",
//                     "X-API-Key": API_KEY,
//                     ...(token && { "Authorization": `Bearer ${token}` })
//                 };

//                 const response = await fetchWithAuth(
//                     plan.id
//                         ? `https://backend.maamaas.com/subscription/api/admin/plans/update/${plan.id}` // PUT /api/admin/plans/update/{id}
//                         : `https://backend.maamaas.com/subscription/api/admin/plans/add`,       // POST
//                     {
//                         method: plan.id ? "PUT" : "POST",
//                         headers,
//                         body: JSON.stringify(payload),
//                     }
//                 );

//                 if (!response.ok) {
//                     const errorData = await response.json().catch(() => ({}));
//                     throw new Error(errorData.message || `Failed saving plan ${plan.days} days`);
//                 }

//                 const savedPlan = await response.json();
//                 savedPlans.push(savedPlan);

//             } catch (err) {
//                 console.error(err);
//                 alert(`Error saving plan ${plan.days} days: ${err.message}`);
//             }
//         }

//         // ✅ Update local state after saving
//         setPlanModuleConfig(prev => {
//             const updated = { ...prev };
//             updated[planType] = updated[planType].map(p => {
//                 const saved = savedPlans.find(sp => sp.days === p.days);
//                 return saved ? saved : p;
//             });
//             return updated;
//         });

//         handleStopEdit(planType);
//         alert("All plans saved successfully!");
//     };





//     if (loading)
//         return <div className="d-flex justify-content-center align-items-center vh-100">Loading...</div>;
//     if (error)
//         return <div className="d-flex justify-content-center align-items-center vh-100 text-danger">Error: {error}</div>;

//     return (
//         <div className="container-fluid food-subscription-data" style={{ paddingTop: "20px", paddingBottom: "20px", }}>
//             <div className="row justify-content-center">
//                 <div className="col-lg-2"></div>
//                 <div className="col-lg-8">
//                     {["BASIC", "PREMIUM"].map(planType => {
//                         const plans = planModuleConfig[planType] || [];
//                         const isEditing = editingPlans[planType];

//                         // Filter modules for BASIC plan
//                         const filteredModules = planType === "BASIC"
//                             ? ALL_POSSIBLE_MODULES.filter(
//                                 m => !["Table_Management", "Chef_Management", "Inventory_Management", "Delivery_Management"].includes(m)
//                             )
//                             : ALL_POSSIBLE_MODULES;

//                         return (
//                             <div className="col-lg-12 " key={planType}>
//                                 <h4 className="mb-3 text-center">{planType} PLAN</h4>
//                                 <div className="table-responsive">
//                                     <table className="table table-bordered text-center align-middle">
//                                         <thead>
//                                             <tr style={{ backgroundColor: "rgb(160, 85, 176)", color: "#fff" }}>
//                                                 <th style={{ backgroundColor: "rgb(160, 85, 176)", color: "#fff" }}>Modules / Days</th>
//                                                 {plans.map((plan, index) => (
//                                                     <th key={index} style={{ backgroundColor: "rgb(160, 85, 176)", color: "#fff" }}>
//                                                         <input
//                                                             type="number"
//                                                             value={plan.days}
//                                                             onChange={e => handleDaysChange(planType, index, e.target.value)}
//                                                             style={{ width: "80px", textAlign: "center" }}
//                                                             readOnly={!isEditing}
//                                                         />
//                                                     </th>
//                                                 ))}
//                                             </tr>
//                                         </thead>

//                                         <tbody>
//                                             <tr>
//                                                 <td><strong>Price (₹)</strong></td>
//                                                 {plans.map(plan => (
//                                                     <td key={plan.days}>
//                                                         <input
//                                                             type="number"
//                                                             value={plan.price}
//                                                             onChange={e =>
//                                                                 handlePriceChange(planType, plan.days, e.target.value)
//                                                             }
//                                                             style={{ width: "100px", textAlign: "center" }}
//                                                             readOnly={!isEditing}
//                                                         />
//                                                     </td>
//                                                 ))}
//                                             </tr>

//                                             {filteredModules.map(moduleName => (
//                                                 <tr key={moduleName}>
//                                                     <td className="text-start">{moduleName.replace(/_/g, " ")}</td>
//                                                     {plans.map(plan => (
//                                                         <td key={`${plan.days}-${moduleName}`}>
//                                                             <input
//                                                                 type="checkbox"
//                                                                 checked={plan.businessModules.includes(moduleName)}
//                                                                 onChange={e =>
//                                                                     handleModuleChange(planType, plan.days, moduleName, e.target.checked)
//                                                                 }
//                                                                 disabled={!isEditing}
//                                                             />
//                                                         </td>
//                                                     ))}
//                                                 </tr>
//                                             ))}

//                                             <tr>
//                                                 <td colSpan={plans.length + 1} className="text-center">
//                                                     {isEditing ? (
//                                                         <button
//                                                             className="btn btn-primary"
//                                                             onClick={() => handleSavePlans(planType)}
//                                                         >
//                                                             Save Plans
//                                                         </button>
//                                                     ) : (
//                                                         <button
//                                                             className="btn btn-warning"
//                                                             onClick={() => handleStartEdit(planType)}
//                                                         >
//                                                             Update Plans
//                                                         </button>
//                                                     )}
//                                                 </td>
//                                             </tr>
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             </div>
//                         );
//                     })}

//                 </div>
//                 <div className="col-lg-2"></div>
//             </div>
//         </div>
//     );
// };

// export default Eventssubscriptiondata;
















import React, { useState, useEffect } from "react";
import './Eventssubscription.css';
import { fetchWithAuth } from "../../../Auth/AuthFetch";
import { useLoader } from '../../../../context/LoaderProvider.jsx';
import { FiEdit2, FiSave, FiCheckCircle, FiPackage, FiCalendar, FiUsers, FiShoppingBag, FiTarget } from "react-icons/fi";
import { AiOutlineDollar } from "react-icons/ai";

const API_BASE_URL = "https://backend.maamaas.com/subscription/api/subscription-plans";
const API_KEY = "your_api_key_here";

// Updated modules for sports/events platform with icons
const MODULES_CONFIG = [
    { name: "Play", icon: <FiPackage />, color: "#4CAF50" },
    { name: "Events", icon: <FiCalendar />, color: "#2196F3" },
    { name: "Coaching", icon: <FiTarget />, color: "#FF9800" },
    // { name: "Shop", icon: <FiShoppingBag />, color: "#9C27B0" },
    // { name: "Team_Management", icon: <FiUsers />, color: "#3F51B5" },
].sort((a, b) => a.name.localeCompare(b.name));

const PLAN_DURATIONS = [90, 180, 365];

const Eventssubscriptiondata = () => {
    const [planModuleConfig, setPlanModuleConfig] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [editingPlans, setEditingPlans] = useState({});
    const { showLoader, hideLoader } = useLoader();


    useEffect(() => {
        const fetchAllPlanData = async () => {
            try {
                setLoading(true);
                showLoader();

                const response = await fetchWithAuth('https://backend.maamaas.com/subscription/api/get/vertical/FOOD_AND_BEVERAGES', {
                    headers: {
                        "X-API-Key": API_KEY,
                        "Accept": "application/json",
                    }
                });

                if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
                const data = await response.json();

                const config = {};

                ["PREMIUM"].forEach(planType => {
                    config[planType] = PLAN_DURATIONS.map(days => {
                        const existing = data.find(p => p.planType === planType && p.days === days);
                        return existing
                            ? {
                                ...existing,
                                price: existing.price || 0,
                                businessModules: Array.isArray(existing.businessModules)
                                    ? existing.businessModules
                                    : []
                            }
                            : {
                                id: null,
                                days,
                                price: 0,
                                planType,
                                businessModules: []
                            };
                    });
                });

                setPlanModuleConfig(config);
            } catch (err) {
                console.error("❌ Fetch plan data failed:", err);
                setError(err.message);
            } finally {
                setLoading(false);
                hideLoader();
            }
        };

        fetchAllPlanData();
    }, []);


    const handleDaysChange = (planType, index, newDays) => {
        setPlanModuleConfig(prev => {
            const updated = { ...prev };
            updated[planType][index] = { ...updated[planType][index], days: Number(newDays) };
            return updated;
        });
    };

    const handlePriceChange = (planType, days, newPrice) => {
        setPlanModuleConfig(prev => {
            const updated = { ...prev };
            updated[planType] = updated[planType].map(p =>
                p.days === days ? { ...p, price: Number(newPrice) } : p
            );
            return updated;
        });
    };

    const handleModuleChange = (planType, days, moduleName, isChecked) => {
        setPlanModuleConfig(prev => {
            const updated = { ...prev };
            updated[planType] = updated[planType].map(plan => {
                if (plan.days === days) {
                    const modules = plan.businessModules || [];
                    return {
                        ...plan,
                        businessModules: isChecked
                            ? [...new Set([...modules, moduleName])]
                            : modules.filter(m => m !== moduleName)
                    };
                }
                return plan;
            });
            return updated;
        });
    };

    const handleStartEdit = planType => {
        setEditingPlans(prev => ({ ...prev, [planType]: true }));
    };

    const handleStopEdit = planType => {
        setEditingPlans(prev => ({ ...prev, [planType]: false }));
    };

    const handleSavePlans = async (planType) => {
        const plans = planModuleConfig[planType] || [];
        const savedPlans = [];


        const token = localStorage.getItem("authToken");

        for (let plan of plans) {
            const payload = {
                price: Number(plan.price) || 0,
                businessModules: plan.businessModules || [],
                planType,
                businessVerticals: "FOOD_AND_BEVERAGES",
                days: plan.days,
            };

            try {

                const headers = {
                    "Content-Type": "application/json",
                    "X-API-Key": API_KEY,
                    ...(token && { "Authorization": `Bearer ${token}` })
                };

                const response = await fetchWithAuth(
                    plan.id
                        ? `https://backend.maamaas.com/subscription/api/admin/plans/update/${plan.id}`
                        : `https://backend.maamaas.com/subscription/api/admin/plans/add`,
                    {
                        method: plan.id ? "PUT" : "POST",
                        headers,
                        body: JSON.stringify(payload),
                    }
                );

                if (!response.ok) {
                    const errorData = await response.json().catch(() => ({}));
                    throw new Error(errorData.message || `Failed saving plan ${plan.days} days`);
                }

                const savedPlan = await response.json();
                savedPlans.push(savedPlan);

            } catch (err) {
                console.error(err);
                alert(`Error saving plan ${plan.days} days: ${err.message}`);
            }
        }


        setPlanModuleConfig(prev => {
            const updated = { ...prev };
            updated[planType] = updated[planType].map(p => {
                const saved = savedPlans.find(sp => sp.days === p.days);
                return saved ? saved : p;
            });
            return updated;
        });

        handleStopEdit(planType);
        alert("All plans saved successfully!");
    };

    if (loading)
        return (
            <div className="d-flex justify-content-center align-items-center vh-100" style={{
                background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)'
            }}>
                <div className="text-center">
                    <div className="spinner-border" style={{
                        width: '3rem',
                        height: '3rem',
                        borderWidth: '0.3em',
                        borderColor: '#b15dc6 transparent transparent'
                    }} role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-3" style={{
                        color: '#666',
                        fontSize: '1.1rem',
                        fontWeight: '500'
                    }}>Loading subscription plans...</p>
                </div>
            </div>
        );

    if (error)
        return (
            <div className="d-flex justify-content-center align-items-center vh-100" style={{
                background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)'
            }}>
                <div className="alert text-center shadow-lg" style={{
                    maxWidth: '500px',
                    border: 'none',
                    borderRadius: '12px',
                    background: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(10px)',
                    borderLeft: '4px solid #f44336'
                }}>
                    <h5 className="alert-heading mb-3" style={{ color: '#f44336' }}>
                        ⚠️ Error Loading Data
                    </h5>
                    <p className="mb-3" style={{ color: '#666' }}>{error}</p>
                    <button className="btn mt-2 px-4 py-2" onClick={() => window.location.reload()} style={{
                        background: 'linear-gradient(45deg, #f44336, #e53935)',
                        color: 'white',
                        border: 'none',
                        borderRadius: '8px',
                        fontWeight: '600',
                        transition: 'all 0.3s ease'
                    }}>
                        Try Again
                    </button>
                </div>
            </div>
        );

    return (
        <div className="container-fluid" style={{
            paddingTop: "30px",
            paddingBottom: "30px",
            minHeight: "100vh",
            marginLeft: '130px',

        }}>
            <div className="row justify-content-center">
                <div className="col-xl-10">
                    <div className="card shadow-lg border-0 overflow-hidden" style={{
                        minWidth: "1000px",
                        width: "100%",
                        border: 'none',
                        borderRadius: '16px',
                        background: 'rgba(255, 255, 255, 0.95)',
                        backdropFilter: 'blur(10px)'
                    }}>


                        <div className="card-body p-5">
                            {["PREMIUM"].map(planType => {
                                const plans = planModuleConfig[planType] || [];
                                const isEditing = editingPlans[planType];

                                return (
                                    <div key={planType}>
                                        <div className="d-flex justify-content-between align-items-center mb-5">
                                            <h4 className="mb-0 d-flex align-items-center" style={{
                                                color: '#333',
                                                fontWeight: '700',
                                                fontSize: '1.8rem'
                                            }}>
                                                <div className="rounded-circle p-3 me-3 d-flex align-items-center justify-content-center shadow"
                                                    style={{
                                                        background: 'linear-gradient(45deg, #b15dc6, #9b59b6)',
                                                        width: '60px',
                                                        height: '60px'
                                                    }}>
                                                    <FiPackage size={26} color="white" />
                                                </div>
                                                SUBSCRIPTION PLANS
                                            </h4>
                                        </div>

                                        <div className="table-responsive rounded-3 overflow-hidden shadow-sm" style={{
                                            borderRadius: '12px',
                                            overflow: 'hidden',
                                            border: '1px solid rgba(0,0,0,0.08)'
                                        }}>
                                            <table className="table table-hover align-middle mb-0" style={{
                                                margin: 0,
                                                border: '1px solid #dee2e6',
                                                borderCollapse: 'collapse'
                                            }}>
                                                <thead style={{
                                                    backgroundColor: "#b15dc6 !important",
                                                    color: "#fff !important",
                                                    border: 'none'
                                                }}>
                                                    <tr>
                                                        <th className="ps-5" style={{
                                                            width: '25%',
                                                            borderBottom: '2px solid #dee2e6',
                                                            padding: '22px 20px',
                                                            fontSize: '1rem',
                                                            fontWeight: '600',
                                                            letterSpacing: '0.5px',
                                                            color: '#fff !important',
                                                            backgroundColor: '#b15dc6 !important',
                                                            borderRight: '1px solid rgba(255,255,255,0.3)'
                                                        }}>
                                                            <div className="d-flex align-items-center">
                                                                <FiPackage className="me-3" size={20} color="white" />
                                                                <span style={{
                                                                    fontSize: '1.1rem',
                                                                    color: '#fff !important',
                                                                    fontWeight: '600'
                                                                }}>MODULES</span>
                                                            </div>
                                                        </th>
                                                        {plans.map((plan, index) => (
                                                            <th key={index} className="text-center" style={{
                                                                borderBottom: '2px solid #dee2e6',
                                                                padding: '22px 20px',
                                                                fontSize: '1rem',
                                                                fontWeight: '600',
                                                                color: '#fff !important',
                                                                backgroundColor: '#b15dc6 !important',
                                                                borderRight: index === plans.length - 1 ? 'none' : '1px solid rgba(255,255,255,0.3)'
                                                            }}>
                                                                <div className="d-flex flex-column align-items-center">
                                                                    <div className="mb-2">
                                                                        <div style={{
                                                                            fontSize: '1.6rem',
                                                                            fontWeight: '700',
                                                                            color: '#fff !important',
                                                                            marginBottom: '5px'
                                                                        }}>
                                                                            {plan.days}
                                                                        </div>
                                                                        <input
                                                                            type="number"
                                                                            value={plan.days}
                                                                            onChange={e => handleDaysChange(planType, index, e.target.value)}
                                                                            className="form-control form-control-sm text-center shadow-sm"
                                                                            style={{
                                                                                width: '90px',
                                                                                fontSize: '1rem',
                                                                                background: 'rgba(255,255,255,0.9)',
                                                                                color: '#b15dc6',
                                                                                fontWeight: '600',
                                                                                border: '2px solid rgba(255,255,255,0.3)',
                                                                                display: isEditing ? 'block' : 'none',
                                                                                margin: '0 auto'
                                                                            }}
                                                                            readOnly={!isEditing}
                                                                        />
                                                                    </div>
                                                                    <small style={{
                                                                        fontSize: '0.9rem',
                                                                        color: '#fff !important',
                                                                        fontWeight: '500'
                                                                    }}>Days Plan</small>
                                                                </div>
                                                            </th>
                                                        ))}
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {/* Price Row */}
                                                    <tr style={{
                                                        background: 'linear-gradient(45deg, #f8f9fa, #e9ecef)',
                                                        borderBottom: '2px solid #dee2e6'
                                                    }}>
                                                        <td className="ps-5 fw-bold" style={{
                                                            padding: '22px 20px',
                                                            fontSize: '1.1rem',
                                                            borderRight: '1px solid #dee2e6'
                                                        }}>
                                                            <div className="d-flex align-items-center">
                                                                <AiOutlineDollar className="me-3" size={22} color="#4CAF50" />
                                                                <span>PRICE (₹)</span>
                                                            </div>
                                                        </td>
                                                        {plans.map((plan, index) => (
                                                            <td key={plan.days} className="text-center" style={{
                                                                padding: '22px 20px',
                                                                borderRight: index === plans.length - 1 ? 'none' : '1px solid #dee2e6'
                                                            }}>
                                                                <div className="input-group input-group-sm justify-content-center">
                                                                    <span className="input-group-text border-0 shadow-sm" style={{
                                                                        background: 'linear-gradient(45deg, #4CAF50, #45a049)',
                                                                        color: 'white',
                                                                        fontWeight: '700',
                                                                        fontSize: '0.95rem'
                                                                    }}>₹</span>
                                                                    <input
                                                                        type="number"
                                                                        value={plan.price}
                                                                        onChange={e => handlePriceChange(planType, plan.days, e.target.value)}
                                                                        className="form-control form-control-sm text-center fw-bold border-0 shadow-sm"
                                                                        style={{
                                                                            width: '140px',
                                                                            background: '#ffffff',
                                                                            fontSize: '1.1rem',
                                                                            color: '#333'
                                                                        }}
                                                                        readOnly={!isEditing}
                                                                    />
                                                                </div>
                                                            </td>
                                                        ))}
                                                    </tr>


                                                    {MODULES_CONFIG.map(({ name, icon, color }) => (
                                                        <tr key={name} style={{
                                                            borderBottom: '1px solid #dee2e6',
                                                            transition: 'all 0.3s ease',
                                                            background: 'white'
                                                        }}>
                                                            <td className="ps-5" style={{
                                                                padding: '20px',
                                                                borderRight: '1px solid #dee2e6'
                                                            }}>
                                                                <div className="d-flex align-items-center">
                                                                    <div className="rounded-circle p-3 me-4 d-flex align-items-center justify-content-center shadow-sm"
                                                                        style={{
                                                                            backgroundColor: color,
                                                                            color: 'white',
                                                                            width: '52px',
                                                                            height: '52px'
                                                                        }}>
                                                                        {React.cloneElement(icon, { size: 22 })}
                                                                    </div>
                                                                    <div>
                                                                        <div className="fw-semibold" style={{
                                                                            fontSize: '1.1rem',
                                                                            color: '#333'
                                                                        }}>{name.replace(/_/g, " ")}</div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            {plans.map((plan, index) => (
                                                                <td key={`${plan.days}-${name}`} className="text-center" style={{
                                                                    padding: '20px',
                                                                    borderRight: index === plans.length - 1 ? 'none' : '1px solid #dee2e6'
                                                                }}>
                                                                    <div className="d-flex justify-content-center align-items-center">
                                                                        <div className="form-check d-flex align-items-center">
                                                                            <input
                                                                                className="form-check-input shadow-sm"
                                                                                type="checkbox"
                                                                                id={`${plan.days}-${name}`}
                                                                                checked={plan.businessModules.includes(name)}
                                                                                onChange={e => handleModuleChange(planType, plan.days, name, e.target.checked)}
                                                                                disabled={!isEditing}
                                                                                style={{
                                                                                    width: '1.5em',
                                                                                    height: '1.5em',
                                                                                    cursor: isEditing ? 'pointer' : 'not-allowed',
                                                                                    border: '2px solid #dee2e6',
                                                                                    marginRight: '12px'
                                                                                }}
                                                                            />

                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            ))}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>


                                        <div className="d-flex justify-content-between align-items-center mt-5 pt-4 border-top" style={{ borderColor: 'rgba(0,0,0,0.1)' }}>
                                            <div className="text-muted small d-flex align-items-center">
                                                <div className="rounded-circle p-2 me-3" style={{
                                                    background: 'linear-gradient(45deg, #f5f7fa, #e9ecef)'
                                                }}>
                                                    <FiPackage size={26} style={{ color: '#b15dc6' }} />
                                                </div>
                                                <span style={{ color: '#666' }}>
                                                    Last updated: {new Date().toLocaleDateString('en-US', {
                                                        weekday: 'long',
                                                        year: 'numeric',
                                                        month: 'long',
                                                        day: 'numeric'
                                                    })}
                                                </span>
                                            </div>
                                            <div className="d-flex gap-3">
                                                {isEditing ? (
                                                    <>
                                                        <button
                                                            className="btn px-4 py-2 shadow-sm"
                                                            onClick={() => handleStopEdit(planType)}
                                                            style={{
                                                                background: 'transparent',
                                                                border: '2px solid #dee2e6',
                                                                borderRadius: '8px',
                                                                fontWeight: '600',
                                                                transition: 'all 0.3s ease',
                                                                color: '#666'
                                                            }}
                                                            onMouseOver={(e) => {
                                                                e.target.style.transform = 'translateY(-2px)';
                                                                e.target.style.boxShadow = '0 6px 12px rgba(0,0,0,0.1)';
                                                            }}
                                                            onMouseOut={(e) => {
                                                                e.target.style.transform = 'translateY(0)';
                                                                e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.05)';
                                                            }}
                                                        >
                                                            Cancel
                                                        </button>
                                                        <button
                                                            className="btn px-4 py-2 shadow-sm"
                                                            onClick={() => handleSavePlans(planType)}
                                                            style={{
                                                                background: 'linear-gradient(45deg, #4CAF50, #45a049)',
                                                                border: 'none',
                                                                borderRadius: '8px',
                                                                fontWeight: '600',
                                                                transition: 'all 0.3s ease',
                                                                color: 'white'
                                                            }}
                                                            onMouseOver={(e) => {
                                                                e.target.style.transform = 'translateY(-2px)';
                                                                e.target.style.boxShadow = '0 6px 12px rgba(76, 175, 80, 0.3)';
                                                            }}
                                                            onMouseOut={(e) => {
                                                                e.target.style.transform = 'translateY(0)';
                                                                e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.05)';
                                                            }}
                                                        >
                                                            <FiSave className="me-2" />
                                                            Save All
                                                        </button>
                                                    </>
                                                ) : (
                                                    <button
                                                        className="btn px-4 py-2 shadow-sm"
                                                        onClick={() => handleStartEdit(planType)}
                                                        style={{
                                                            background: 'linear-gradient(45deg, #b15dc6, #9b59b6)',
                                                            border: 'none',
                                                            borderRadius: '8px',
                                                            fontWeight: '600',
                                                            transition: 'all 0.3s ease',
                                                            color: 'white'
                                                        }}
                                                        onMouseOver={(e) => {
                                                            e.target.style.transform = 'translateY(-2px)';
                                                            e.target.style.boxShadow = '0 6px 12px rgba(177, 93, 198, 0.3)';
                                                        }}
                                                        onMouseOut={(e) => {
                                                            e.target.style.transform = 'translateY(0)';
                                                            e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.05)';
                                                        }}
                                                    >
                                                        <FiEdit2 className="me-2" />
                                                        Edit Plan
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Eventssubscriptiondata;